import axiosInstanceNew from "../lib/axiosinstanceNew";

const TestUserModel = class {
  
  constructor() {
    this.baseUrl = "test_users";
  }
  async list() {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}`)
    ).data;
  }
  async add(data= []) {
    return (
      await axiosInstanceNew.post(`${this.baseUrl}`,data))
  }
  
  async delete(id) {
    return (
      await axiosInstanceNew.delete(`${this.baseUrl}/${id}`))
  }
};

export default new TestUserModel();